module.exports = __webpack_public_path__ + "static/img/ent-detail-64.6887e16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-64.jpg
// module id = xxTw
// module chunks = 51